import React from "react";
import HomeWelcome from "./HomeWelcome/HomeWelcome";
import HomeServices from "./HomeServices/HomeServices";
import HomeOfficePhotos from "./HomeOfficePhotos/HomeOfficePhotos";
import HomeQuest from "./HomeQuest/HomeQuest";
import HomeForms from "./HomeForms/HomeForms";
import HomeContact from "./HomeContact/HomeContact";
import Moving from "./Moving/Moving";
import Workspace from "./Workspace/Workspace";

const Home = () => {
  return (
    <section>
      <Workspace />
      <Moving />
      <HomeWelcome />
      <HomeServices />
      <HomeForms />
      <HomeQuest />
      <HomeOfficePhotos />
      <HomeContact />
    </section>
  );
};

export default Home;
